import { render, staticRenderFns } from "./InternationalTables.vue?vue&type=template&id=55427ca2&"
import script from "./InternationalTables.vue?vue&type=script&lang=js&"
export * from "./InternationalTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports